import { FormattedMessage, useIntl } from "react-intl";
import { Stack as MuiStack } from "@mui/material";

import { DateInput } from "@dzambalaorg/mui-inputs-picker";
import { SelectInput, TextInput } from "@dzambalaorg/mui-inputs-core";
import { RichTextEditor } from "@dzambalaorg/mui-inputs-draft";
import { TemplateAssetInput } from "@dzambalaorg/mui-inputs-asset";
import { AchievementRuleStatus, ContractFeatures, ContractStatus } from "@framework/types";
import { FormGrid, Typography } from "@dzambalaorg/ui-kit";

import { ContractInput } from "./contract";
import { SelectContractEventTypeInput } from "./contract-event-type-select";

export const AchievementRuleEditDialog = () => {
  const { formatMessage } = useIntl();
  return (
    <FormGrid columns={[2, 2, 1, 2, 1]}>
      <TextInput name="title" />
      <SelectInput name="achievementStatus" options={AchievementRuleStatus} />
      <ContractInput
        name="contractId"
        related="address"
        controller="contracts"
        data={{ excludeFeatures: [ContractFeatures.EXTERNAL], contractStatus: [ContractStatus.ACTIVE] }}
      />
      <SelectContractEventTypeInput />
      <MuiStack>
        <Typography variant="h6">
          <FormattedMessage id="form.labels.achievementItem" />
        </Typography>
        <TemplateAssetInput autoSelect multiple prefix="item" showLabel={false} />
      </MuiStack>
      <DateInput
        slotProps={{
          popper: {
            sx: {
              "& .MuiPickersTextField-root": {
                margin: 0,
              },
            },
          },
        }}
        name="startTimestamp"
        label={formatMessage({ id: "form.labels.startTimestamp" })}
        size="small"
      />
      <DateInput
        slotProps={{
          popper: {
            sx: {
              "& .MuiPickersTextField-root": {
                margin: 0,
              },
            },
          },
        }}
        name="endTimestamp"
        label={formatMessage({ id: "form.labels.endTimestamp" })}
        size="small"
      />
      <RichTextEditor name="description" />
    </FormGrid>
  );
};
